/**
 * Created by fworld on 2019/9/26.
 */

import request from '@/util/request'

export const maintainSetDeviceParamTmplUnion = (params) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/union',
        method: 'get',
        params
    })
}


export const maintainSetDeviceParamTmplList = (params) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/list',
        method: 'get',
        params
    })
}

export const maintainSetDeviceParamTmplCreate = (data) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/create',
        method: 'post',
        data
    })
}

export const maintainSetDeviceParamTmplUpdate = (data) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/update',
        method: 'post',
        data
    })
}

export const maintainSetDeviceParamTmplParam = (params) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/params',
        method: 'get',
        params
    })
}


export const maintainSetDeviceParamTmplParamUpdate = (data) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/param/update',
        method: 'post',
        data
    })
}

export const maintainSetDeviceParamTmplDeviceUnion = (params) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/device/union',
        method: 'get',
        params
    })
}

export const maintainSetDeviceParamTmplDeviceList = (params) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/device/list',
        method: 'get',
        params
    })
}

export const maintainSetDeviceParamTmplDeviceBind = (data) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/device/bind',
        method: 'post',
        data
    })
}

export const maintainSetDeviceParamTmplDeviceResetFee = (params) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/device/resetFee',
        method: 'get',
        params
    })
}

export const maintainSetDeviceParamTmplDeviceApplyParam = (params) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/device/applyParam',
        method: 'get',
        params
    })
}

export const maintainSetDeviceParamTmplDeviceUnBind = (params) => {
    return request({
        url: '/api/v1/delivery/maintainSet/deviceParamTmpl/device/unbind',
        method: 'get',
        params
    })
}



